import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminBoardComponent } from './composants/admin-board/admin-board.component';
import { UserBoardComponent } from './composants/user-board/user-board.component';
import { SupervisorBoardComponent } from './composants/supervisor-board/supervisor-board.component';
const routes: Routes = [
{ path: 'admin-board', component: AdminBoardComponent},
{ path: 'user-board', component: UserBoardComponent},
{ path: 'supervisor-board', component: SupervisorBoardComponent},
{ path: 'user-board/:type', component: UserBoardComponent},
{ path: 'admin-board/:type', component: AdminBoardComponent},
{ path: 'admin-board/:type', component: AdminBoardComponent},
{ path: 'admin-board/:type', component: AdminBoardComponent},
{ path: 'admin-board/:type', component: AdminBoardComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
